<div class="container my-4">
    <div class="row mb-4">
        <div class="col-12">
            <span class="title_header_bar">View All FNO Packages</span>
        </div>
    </div>
    <!-- <div class="col-xl-12">
        <ng-container *ngIf="ConnectionDetails?.length > 0">
            <owl-carousel-o [options]="carouselOptions" class="packages_owl_item">
                <ng-container *ngFor="let slide of ConnectionDetails;let i = index">
                    <ng-template carouselSlide [id]="i.toString()">
                        <div class="providers-container-afterlogin"
                            [ngClass]="{'-active-provider': slide.serviceProviderId === activeProvider}"
                            (click)="selectedProviderPackage(slide)">
                            <img class="providers-img"
                                [style.width]="slide.providerName=='Kikuyu Estate Residents'?'210px':'155px'"
                                src="../../../../../assets/images/providersImg/{{slide.providerName}}.svg">
                        </div>
                    </ng-template>
                </ng-container>
            </owl-carousel-o>
        </ng-container>
    </div> -->
    <!-- <div class="row p-4">
        <div class="providers-container-afterlogin" *ngFor="let slide of ConnectionDetails; let i = index"
            [ngClass]="{'-active-provider': slide.serviceProviderId === activeProvider}"
            (click)="selectedProviderPackage(slide)">
            <img class="providers-img"
                [style.width]="slide.providerName=='Kikuyu Estate Residents'?'210px':'155px'"
                src="../../../../../assets/images/providersImg/{{slide.providerName}}.svg">
        </div>
    </div> -->
    <!-- <div class="row_class p-4 scale-in-hor-center" *ngIf="!contentShow">
        <div class="col-3_class" *ngFor="let slide of ServiceProvidersList; let i = index">
            <div class="providers-container-afterlogin" (click)="selectedProviderPackage(slide);contentShow=true"> -->
                <!-- [ngClass]="{'-active-provider': slide.serviceProviderId === activeProvider}" -->

                <!-- <img class="providers-img" [style.width]="slide.providerName=='Kikuyu Estate Residents'?'210px':'155px'"
                    src="../../../../../assets/images/providersImg/{{slide.providerName}}.svg">
            </div>
        </div>
    </div> -->


    <div class="row p-4 scale-in-hor-center" *ngIf="!contentShow">
        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-4" *ngFor="let slide of ServiceProvidersList; let i = index">
            <div class="providers-container-afterlogin"(click)="selectedProviderPackage(slide); contentShow=true">
            <div class="img-text" *ngIf="slide.providerName === 'Purple Forest -Waterfall View'">
                PURPLE FOREST - WATERFALL VIEW
            </div>
            <img *ngIf="slide.providerName !== 'Purple Forest -Waterfall View'" class="providers-img"
                [style.width]="slide.providerName=='Kikuyu Estate Residents'?'210px':'155px'"
                src="../../../../../assets/images/providersImg/{{slide.providerName}}.svg">
        </div>
        </div>
    </div>

    <div class="row">
        <div class="col-xl-12 text-right" *ngIf="contentShow">
            <button (click)="this.contentShow=false" class="btn btn-primary">Go Back</button>
        </div>
    </div>
    <div class="row scale-in-hor-center" *ngIf="contentShow">
        <div class="packages col-md-12">
            <div class="row packages-container" style="text-wrap:nowrap ;">
                <ng-container>
                    <div *ngFor="let grouppedProducts of productList[0].productDetailSpecificSpeeds "
                        class="col-xs-12 col-lg-4 col-md-6 col-sm-9 col-xl-3">
                        <div *ngIf="productList[0].isImportantProduct">

                            <div class="package amt-package" style="padding: 0;padding-bottom: 20px;padding-right: 10px;
                        padding-left: 10px; background: linear-gradient(0deg, #03CEB6  17%, #E300D9 83%);">
                                <div class="row">
                                    <div class="col-2"></div>
                                    <div class="col-8 mostpopular">
                                        <span style="margin-top: 4px;">Most Popular</span>
                                    </div>
                                    <div class="col-2"></div>
                                </div>

                                <div class="package-card"
                                    style="background: none !important;margin-top: 20px !important;"
                                    *ngIf="!productList[0].isModifiedProduct">
                                    <h3> R {{grouppedProducts.cost | trunc }}</h3>
                                    <h6 class="per-month">Per Month</h6>
                                </div>

                                <div class="package-card"
                                    style="background: none !important;margin-top: 20px !important;"
                                    *ngIf="productList[0].isModifiedProduct">
                                    <h3>R {{grouppedProducts.promotionCost | trunc }}</h3>
                                    <h6 class="per-month">Per Month</h6>
                                </div>

                                <div class="package-card"
                                    style="background: none !important;margin-top: 20px !important;"
                                    *ngIf="productList[0].isModifiedProduct">
                                    <h3>R {{grouppedProducts.cost | trunc }}</h3>
                                    <h6 class="per-month">Per Month</h6>
                                </div>



                                <h6 class="head-openserve" style="margin-top:12px;">
                                    {{productList[0].providerName}}</h6>
                                <div class=" mbps" style="margin-top: 10px !important;">
                                    <div class="content-left"
                                        style="position: relative;top: 8px;left: -9px;">
                                        <p class="download-speed">
                                            <strong
                                                style="font-size: 30px;">{{grouppedProducts.downloadSpeed}}</strong>&nbsp;<br><span
                                                style="font-size: 13px;">Mbps</span>
                                        </p>
                                        <img class="down-up"
                                            src="../../../../assets/images/providersImg/download-1.svg"
                                            height="30px">
                                        <p class="cont-title">Download<br />Speed</p>


                                    </div>
                                    <div class="line"></div>
                                    <div class="content-left"
                                        style="position: relative;top: 8px;left: -5px;">
                                        <p class="download-speed">
                                            <strong
                                                style="font-size: 30px;">{{grouppedProducts.uploadSpeed}}</strong>&nbsp;<br /><span
                                                style="font-size: 13px;">Mbps</span>
                                        </p>
                                        <img class="down-up"
                                            src="../../../../assets/images/providersImg/upload-1.svg"
                                            height="30px">
                                        <p class="cont-title">Upload<br />Speed</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="!productList[0].isImportantProduct">
                            <div class="package amt-package"
                                [class.package-limit]="productList[0].isModifiedProduct">
                                <div class="row" *ngIf="productList[0].isModifiedProduct"
                                    style="margin-top: -20px;">
                                    <div class="col-2 "></div>
                                    <div class="col-8 limitedoffer">
                                        <span style="margin-top: 4px;font-size: 20px;">Limited Offer</span>
                                    </div>
                                    <div class="col-2"></div>
                                </div>

                                <div class="package-card" style="margin-top: 40px !important"
                                    *ngIf="!productList[0].isModifiedProduct">
                                    <h3>R {{grouppedProducts.cost | trunc }}</h3>
                                    <h6 class="per-month">Per Month</h6>
                                </div>



                                <div class="package-card"
                                    [class.pack-card]="productList[0].isModifiedProduct"
                                    style="margin-top: 20px !important"
                                    *ngIf="productList[0].isModifiedProduct">
                                    <h4>
                                        R {{grouppedProducts.promotionCost | trunc }} / <span
                                            style="text-decoration: line-through;color: #d4cece;">R{{grouppedProducts.cost
                                            | trunc }}</span></h4>
                                    <h6 class="per-month">Per Month</h6>
                                </div>


                                <h6 class="head-openserve"
                                    style="margin: 0;margin-top: 10px;margin-bottom: 10px;">
                                    {{productList[0].providerName}}
                                </h6>

                                <div class=" mbps">
                                    <div class="content-left"
                                        style="position: relative;top: 8px;left: -9px;">
                                        <p class="download-speed">
                                            <strong
                                                style="font-size: 30px;">{{grouppedProducts.downloadSpeed}}</strong>&nbsp;<br><span
                                                style="font-size: 13px;">Mbps</span>
                                        </p>
                                        <img class="down-up"
                                            src="../../../../assets/images/providersImg/download-1.svg"
                                            height="30px">
                                        <p class="cont-title">Download<br />Speed</p>


                                    </div>
                                    <div class="line"></div>
                                    <div class="content-left"
                                        style="position: relative;top: 8px;left: -5px;">
                                        <p class="download-speed">
                                            <strong
                                                style="font-size: 30px;">{{grouppedProducts.uploadSpeed}}</strong>&nbsp;<br /><span
                                                style="font-size: 13px;">Mbps</span>
                                        </p>
                                        <img class="down-up"
                                            src="../../../../assets/images/providersImg/upload-1.svg"
                                            height="30px">
                                        <p class="cont-title">Upload<br />Speed</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
    <!-- <div class="row scale-in-hor-center" *ngIf="contentShow">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-top:30px;"
            *ngFor="let productCategory of this.ConnectionDetails">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4"
                    style="border-bottom:2px solid lightgrey;padding-top:20px;">
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                    <h6
                        style="text-align:center;font-weight:bold;font-size:16px;letter-spacing:1px;text-transform: uppercase;">
                        {{productCategory.providerName}}
                    </h6>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4"
                    style="border-bottom:2px solid lightgrey;padding-top:20px;">
                </div>
            </div>
            <div ng-show="this.serviceProviderId == this.Configuration.CenturyCityConnect || this.isResellerCustomer"
                style="margin-top:40px;">
            </div>
            <div *ngFor="let product of productCategory.productDetailSpecificSpeeds" style="top:12px">
                <div class="row col-md-12">
                    <div class="row col-md-12">
                        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 package3">
                            <div class="col-md-12 packagesprice">
                                <label style="font-weight:bold;margin-top:20px;">
                                    Download Speed
                                </label>
                                <h3 style="color:#00AFFF;font-weight: bold;margin-top: 0px;">
                                    {{product.downloadSpeed}} Mb/s
                                </h3>
                                <label style="font-weight:bold;">
                                    <span>
                                        Upload Speed:
                                    </span>
                                    <span style="color:#00AFFF;">
                                        {{product.uploadSpeed}} MB/S
                                    </span>
                                </label>
                                <label
                                    style="border-top:1.5px solid lightgrey;margin-top:20px;font-weight:bold;width:200px;">
                                    {{productCategory.providerName}}
                                </label>
                                <h3 style="font-weight: bold;">
                                    R{{product.cost}}
                                    <span style="font-size:18px;">
                                        PM
                                    </span>
                                </h3>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 package3">
                                <div class="col-md-12 packagesprice" style="background-color:#8224E3" ;>
                                    <div
                                        style="font-weight:bold;color:#FFFFFF;text-align:right;font-size:11px;font-family:Muli!important;">
                                        MOST POPULAR
                                    </div>
                                    <label style="font-weight:bold;color:#FFFFFF;">
                                        Download Speed
                                    </label>
                                    <h3 style="color:#FFFFFF;font-weight: bold;margin-top: 0px;">
                                        {{product.downloadSpeed}} Mb/s
                                    </h3>
                                    <label style="font-weight:bold;color:#FFFFFF;">
                                        <span>
                                            Upload Speed:
                                        </span>
                                        <span style="color:#FFFFFF;">
                                            {{product.uploadSpeed}} MB/S
                                        </span>
                                    </label>
                                    <label
                                        style="border-top:1.5px solid lightgrey;margin-top:16px;font-weight:bold;width:200px;color:#FFFFFF;">
                                        {{productCategory.providerName}}
                                    </label>
                                    <h3 style="font-weight: bold; color:#FFFFFF">
                                        <span style="font-size:16px; color:#FFFFFF">
                                            PM
                                        </span>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->

</div>
